import { Component, OnInit, Input, Output, EventEmitter, ViewChild } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { AguaBuscaCuentasService } from "../../servicios/agua-busca-cuentas.service";
import { AguaBuscaCuentas, AguaBuscaCuentasInput } from "../../entidades/entidades";
import { AguasService } from "../../servicios/aguas.service";
import { Aguas } from "../../entidades/entidades";
import { MuestraMensaje } from "../../shared/utilerias/notificaciones/notificaciones.component";
import { AguaBuscaCuentasGridComponent } from "../agua-busca-cuentas-grid/agua-busca-cuentas-grid.component";
import { SelectItem } from "primeng/api";
declare var $: any;

@Component({
  selector: 'app-agua-busca-cuenta-online',
  templateUrl: './agua-busca-cuenta-online.component.html',
  styleUrls: ['./agua-busca-cuenta-online.component.css']
})
export class AguaBuscaCuentaOnlineComponent implements OnInit {
  private actionUrl: string;
  datosCuentaAguaForm: FormGroup;
  datosAguaCuenta = new AguaBuscaCuentasInput();
  datosAguas = new Aguas();
  @Input() mostrarCuenta: boolean = true;
  flagPagoEnLinea: boolean = true;
  @Input("aguaBuscaCuentas") aguaBuscaCuentas: EventEmitter<AguaBuscaCuentas>;
  @Output("aguasOutput") aguasOutput: EventEmitter<Aguas>;
  @Output() busquedaIniciada: EventEmitter<void> = new EventEmitter<void>();
  @Output() busquedaFinalizada: EventEmitter<void> = new EventEmitter<void>();
  buscando: boolean = false;
  muestraMensaje = new MuestraMensaje();
  
  
  constructor(
    private formBuilder: FormBuilder,
    private aguasService: AguasService,
    private aguaBuscaCuentasService: AguaBuscaCuentasService
  ) {

    this.aguasOutput = new EventEmitter();
    this.aguaBuscaCuentas = new EventEmitter();
  }
  

  ngOnInit() {
  
    this.datosCuentaAguaForm = this.formBuilder.group({
      cuentaAgua: [undefined],
      nRazonSocialAgua: [undefined],
      domicilioAgua: [undefined],
      medidorAgua: [undefined],
    });
    
  }
  async buscaCuentaAgua() {
    
    if (this.buscando) {
      return;
    }
    try {
      this.busquedaIniciada.emit(); 
      this.buscando = true;
      this.aguasOutput.emit(null);
      this.aguaBuscaCuentas.emit(null);
     
      this.datosAguaCuenta.cuentaAgua = this.datosCuentaAguaForm.value.cuentaAgua;
      if (this.datosAguaCuenta.cuentaAgua == null) {
        this.muestraMensaje.error('Ingresa una cuenta para la busqueda', 'top', 'center'); return
      }
      // console.log('datosAguaCuenta', this.datosAguaCuenta)

      const datoretorno = await this.aguaBuscaCuentasService
        .add(this.datosAguaCuenta)
        .toPromise();

      // console.log('datoretorno', datoretorno)

      if (Object.keys(datoretorno).length == 1) {
        // console.log("CUENTAAGUACOMUN", datoretorno);
        this.getAguas(datoretorno[0].id);
        // this.muestraMensaje.notification("Registro encontrado.", "top", "center");
      } else if (Object.keys(datoretorno).length >= 2) {
        // console.log("CUENTADERIVADA", datoretorno);

        this.aguaBuscaCuentas.emit(datoretorno);
        this.datosCuentaAguaForm.reset();
        $("#exampleModalLong").modal()

      } else {
        //DatosAguaSolicitudes
        this.busquedaFinalizada.emit();
        this.datosCuentaAguaForm.reset();
        this.muestraMensaje.error("No se encontró registro.", "top", "center");
      }

    } catch (e) {
      if (e.response) {
        throw { message: e.response.data };
      } else {
        throw e;
      }
    } finally {
      // console.log("Paso por AguaBuscaCuenta");
      this.buscando = false;
    }
  }
  async getAguas(id: number) {
    try {
      const datoRetorno = await this.aguasService.getSingle(id).toPromise();
      
      this.aguasOutput.emit(datoRetorno);
    } catch (e) {
      if (e.response) {
        throw { message: e.response.data };
      } else {
        throw e;
      }
    } finally {
      // console.log("Paso por getAguas");

    }
  }

  async childAguaBuscaCuentasGrid(aguas: Aguas) {
 
    // console.log("TRAJO AGUAS", aguas);
    $("#exampleModalLong").modal('hide')
    if (!aguas) {
      this.aguasOutput.emit(null);
      return;
    }
    this.aguasOutput.emit(aguas);
    
  }

}
